import React from "react";
import {Section} from "./Section";
import {Card, Typography, Row, Col, Space, Tag} from "antd";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";



export const Warehouse = ({data,fetchConfig})=>{
    return <Section
        title={"Warehouses"}
        data={data}
        schema={"reg_approval_warehouse_vat"}
        fetchConfig={async ()=>{
            return await fetchConfig({schema: "reg_approval_warehouse_vat"})
        }}
        resolve={(props)=>{
            console.log(props)
            switch (props.name){
                case "self_reg_warehouse_vat":
                    return (data.self_reg_warehouse_vat || []).map((o,i)=>{
                        return <Card title={`#${i}`} key={i} style={{width: 500}}>
                            <tr className={"section-item"}>
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>VAT ID</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                    <Typography.Text>{o.vat_id}</Typography.Text>
                                </td>
                            </tr>
                            <tr className={"section-item"}>
                                <td style={{textAlign: 'right', paddingRight: 20}}>
                                    <Typography.Text>Country</Typography.Text>
                                </td>
                                <td style={{textAlign: 'left',paddingLeft: 20}}>
                                        {resolve({...props, value: o.country_id})}
                                </td>
                            </tr>
                        </Card>
                    });
                default:
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
            }
        }}
    />
}
